const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const getAccessToken = (): string | null => {
  return localStorage.getItem('user_token');
};

// 1. refresh token으로 access token 재발급
export const refreshAccessToken = async (): Promise<string> => {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) {
    alert('로그인이 필요합니다.');
    throw new Error('No refresh token');
  }

  const res = await fetch(`${API_BASE_URL}/user/auth/renew_session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh_token: refreshToken }),
  });

  if (!res.ok) {
    alert('세션이 만료되었습니다. 다시 로그인 해주세요.');
    localStorage.removeItem('user_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/login'; // 강제 로그인 페이지 이동
    throw new Error('Token refresh failed');
  }

  const data = await res.json();
  localStorage.setItem('user_token', data.body.access_token);
  if (data.body.refresh_token) {
    localStorage.setItem('refresh_token', data.body.refresh_token);
  }
  return data.body.access_token;
};

// 2. 인증 fetch + 401 자동 재시도 (JSON + FormData 모두 지원)
export const authFetch = async (
  input: RequestInfo,
  init?: RequestInit,
  retry = true
): Promise<Response> => {
  let token = getAccessToken();
  const isFormData = init?.body instanceof FormData;

  let response = await fetch(
    input.toString().startsWith('http') ? input : API_BASE_URL + input,
    {
      ...init,
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }), // FormData는 Content-Type 자동 설정
        ...(init?.headers || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );

  // access token 만료 → refresh 후 재시도
  if (response.status === 401 && retry) {
    try {
      token = await refreshAccessToken();
      response = await fetch(
        input.toString().startsWith('http') ? input : API_BASE_URL + input,
        {
          ...init,
          headers: {
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            ...(init?.headers || {}),
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error('토큰 갱신 실패:', err);
      throw err;
    }
  }

  return response;
};

// 3. 예시: 공간 업로드
export const uploadSpace = async (formData: FormData) => {
  const response = await authFetch('/space/spaces', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `Failed to upload space: ${response.status}`);
  }

  return response;
};
